module.exports = __webpack_public_path__ + "static/media/mba.3333af6f.jpg";